<template>
  <div>
    <b-row>
      <b-colxx xxs="12">
        <piaf-breadcrumb :heading="$t('menu.booking-visit')"/>
        <div class="separator mb-5"></div>
      </b-colxx>
    </b-row>

    <b-row>
      <b-colxx xxs="12">
        <b-card class="mb-4" title="예약조회">
          <b-row class="mb-3">
            <b-col xxs="12">
              <b-input-group>
                <template v-slot:prepend>
                  <b-button @click="onClickPrev()" variant="outline-primary">◀</b-button>
                </template>
                <v-date-picker
                  mode="single"
                  v-model="searchDate"
                  :input-props="{ class:'form-control', placeholder: '' }"
                >
                </v-date-picker>
                <template v-slot:append>
                  <b-input-group-text class="d-none d-xs-block">
                    <b-icon icon="calendar"></b-icon>
                  </b-input-group-text>
                  <b-button @click="onClickNext()" variant="outline-primary">▶</b-button>
                </template>
              </b-input-group>
            </b-col>
          </b-row>

          <b-row align-v="center" class="justify-content-start mb-1" no-gutters>
            <b-colxx xxs="12" lg="10" xxl="6">
              <b-input-group class="mb-3">
                  <v-select :options="searchOptions" v-model="searchKind" :reduce="item=>item.value" label="label"
                            class="col-xss-12 mr-1 newSelect"></v-select>

                <b-input :placeholder="searchPlaceholder" v-model.trim="searchKeyword"
                         :maxlength="searchKind == 'PhoneNumber4' ? 4 : 13" class="  d-sm-block"
                         @input="onlyNumberCheck" @keyup.enter="onSearch"/>

                <b-input-group-append>
                  <b-button @click="onSearch" variant="outline-primary default">
                    {{$t('button.search')}}
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-colxx>
          </b-row>


          <template v-if="isLoad">

            <booking-list
              :items="items"
              :fields="fields"
              :per-page="perPage"
              :currentPage="currentPage"
              :data="bookingInfo"
              @click-row="onClickRow"
              @confirm-proc=""
              @visited-cancel="visitedShow"
              @deny-proc=""
            />

            <b-pagination v-if="lastPage > 1"
                          size="sm"
                          align="center"
                          :total-rows="total"
                          :per-page="perPage"
                          v-model="currentPage"
            >
              <template v-slot:next-text>
                <i class="simple-icon-arrow-right"/>
              </template>
              <template v-slot:prev-text>
                <i class="simple-icon-arrow-left"/>
              </template>
              <template v-slot:first-text>
                <i class="simple-icon-control-start"/>
              </template>
              <template v-slot:last-text>
                <i class="simple-icon-control-end"/>
              </template>
            </b-pagination>
          </template>

          <template v-else>
            <div class="loading"></div>
          </template>


          <template>
            <b-row align-v="center" align-h="center" class="mt-0" no-gutters>
              <b-modal id="bookingdetails" ref="bookingdetails" size="lg" title="예약 상태" :hide-backdrop="false"
                       :no-close-on-backdrop="true">
                <booking-visit-detail v-bind:data="bookingInfo" :modifyFlag="false"
                                      :checkUseFlag="bookingInfo.bookingStatus === 'Booked' ? true : false"/>

                <template slot="modal-footer">
                  <b-button variant="outline-primary" @click="hideModal()">닫기</b-button>
                  <b-button variant="danger" @click="cancelReservation" v-if="bookingInfo.bookingStatus === 'Booked'">
                    예약취소
                  </b-button>
                  <b-button variant="danger" class="mr-1" @click="setNoShow"
                            v-if="bookingInfo.bookingStatus === 'Booked'">노쇼
                  </b-button>
                  <b-button variant="primary" class="mr-1" @click="setVisited()"
                            v-if="bookingInfo.bookingStatus === 'Booked'">방문완료처리
                  </b-button>
                </template>
              </b-modal>
            </b-row>
          </template>

          <!-- 예약방문 처리내역 조회모달  -->
          <booking-visited-cancel ref="modal_visited_cancel" :data="visitedInfo" :noShowFlag="noShowFlag"
                                  @process="visitedCancel" @noshow="cancelNoShow"/>
        </b-card>
      </b-colxx>
    </b-row>
  </div>

</template>

<script>
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import api from '../../../constants/api'
import BookingVisitDetail from '../components/mobile/BookingDetailViewMobile'
import BookingList from "../components/mobile/BookingListMobile";
import {alignTableCenter, eventBus} from '../../../utils'
import BookingVisitedCancel from "../components/BookingVisitedCancel";

import {
  mapGetters,
  mapActions,
  mapMutations
} from "vuex";

export default {
  components: {
    'v-select': vSelect,
    'booking-visit-detail': BookingVisitDetail,
    'booking-list': BookingList,
    'booking-visited-cancel': BookingVisitedCancel
  },


  data() {
    return {
      noShowFlag: null,
      transProps: {
        // Transition name
        name: 'list'
      },
      searchKind: 'PhoneNumber4',
      searchOptions: [
        {label: '전화번호', value: 'PhoneNumber4'},
        {label: '예약번호', value: 'BookingNo'},
      ],
      searchDate: this.$route.query.searchDate ? this.$moment(this.$route.query.searchDate).toDate() : new Date(),
      isLoad: false,
      searchFlag: false,
      currentPage: 1,
      perPage: 30,
      lastPage: 1,
      total: 1,
      searchKeyword: "",
      items: [],
      fields: [
          {key: 'visitorName', label: "", ...alignTableCenter},
          {key: 'headcount', label: "", ...alignTableCenter},
          {key: 'reservationDate', label: "", ...alignTableCenter},
          {key: 'visitorRequests', label: "", ...alignTableCenter},
        ],
      bookingInfo: {
        bookingNo: null,
        visitorName: null,
        visitorPhone: null,
        visitorRequests: null,
        storeName: null,
        reservationDate: null,
        bookingRequestDate: null,
        bookingStatus: null,
        orderItems: [],
      },
      selectedBookingNo: null,
      visitedInfo: [],
    }
  },

  mounted() {
    this.searchData();
  },
  created(){

  },

  watch: {
    currentPage() {
      this.searchData()
    },
    searchDate(value) {
      if(value) {
        this.searchData()
      }
    },
    noShowFlag() {
    }
  },

  computed: {
    ...mapGetters(['currentUser', 'siteName']),
    searchPlaceholder: {
      get: function() {
        return this.searchKind === "PhoneNumber4" ? "전화번호 뒷 4자리를 입력하세요." : "예약번호를 입력하세요";
      }
    }
  },

  methods: {
    onlyNumberCheck(value) {
      let val = value.replace(/[^0-9]/g, '')
      this.searchKeyword = val
    },
    showModal() {
      this.$refs['bookingdetails'].show();
    },
    hideModal() {
      this.$refs['bookingdetails'].hide();
    },
    onClickPrev() {
      this.searchDate = this.$moment(this.searchDate).subtract(1, 'day').toDate()
    },
    onClickNext() {
      this.searchDate = this.$moment(this.searchDate).add(1, 'day').toDate()
    },

    onSearch() {
      if(this.searchKeyword === "") {
        alert('검색어를 숫자만 입력하세요');
        return false
      }
      this.currentPage = 1
      // this.searchFlag = true
      this.searchData()
    },

    searchCancel() {
      this.searchFlag = false
      this.searchKeyword = ""
      this.searchData()
    },


    /** *************************************************************************************************************/
    searchData() {
      this.isLoad = true;
      this.items = [];

      const reqURL = api.changeAPI(this.siteName, api.basicURL + api.order.bookingList)

      let _keywordType = this.searchKeyword === "" ? "NoKeyword" : this.searchKind  //키워드 내용없을경우
      const params = {
        dateType: "VisitDate",
        dateFrom: this.$moment(this.searchDate).format('YYYY-MM-DD'),
        dateTo: this.$moment(this.searchDate).format('YYYY-MM-DD'),
        keywordType: _keywordType,
        keyword: this.searchKeyword,
        pageNumber: (this.currentPage - 1),
        pageSize: this.perPage,
      }

      this.$http.post(reqURL, params, {
        headers: {'Authorization': `Bearer ${this.currentUser.tokens.access.token}`}
      }).then(res => {
        if(res.data.code === "OK") {
          //
          const _data = res.data.data
          this.lastPage = res.data.totalPages
          this.total = res.data.totalElements
          this.items = _data.content
        } else {
          throw 400
        }
      }).catch(err => {
        alert(err.response.data.message);
      })

    },


    onClickRow(item, bookingNo) {
      this.selectedBookingNo = bookingNo
      const reqURL = api.changeAPI(this.siteName, api.basicURL + api.order.bookingDetail)
      const params = {
        bookingNo: bookingNo
      }
      this.$http.post(reqURL, params, {
        headers: {'Authorization': `Bearer ${this.currentUser.tokens.access.token}`}
      }).then(res => {
        if(res.data.code === "OK") {
          this.bookingInfo = res.data.data.bookingDetails
          this.showModal();
        } else {
          throw 400
        }
      }).catch(err => {
        alert(err.response.data.message);
      })
    },


    //예약취소
    cancelReservation() {

      // if(confirm('해당 예약을 취소하시겠습니까? ')) {
      //   const reqURL = api.changeAPI(this.siteName, api.basicURL + api.order.cancelBooking)
      //   const params = {
      //     bookingNo: this.selectedBookingNo
      //   }

      //   eventBus.$emit('bus-event', true);
      //   this.$http.post(reqURL, params,
      //     {headers: {'Authorization': `Bearer ${this.currentUser.tokens.access.token}`}}
      //   ).then(res => {
      //     eventBus.$emit('bus-event', false);
      //     if(res.data.code === "OK") {
      //       alert('해당 예약이 취소 되었습니다.');
      //       this.hideModal()
      //       this.searchData()
      //     } else {
      //       throw 400
      //     }
      //   }).catch(err => {
      //     eventBus.$emit('bus-event', false);
      //     alert(err.response.data.message);
      //   })
      // }

    },


    //예약노쇼처리
    setNoShow() {

      if(confirm('노쇼처리 하시겠습니까? ')) {
        const reqURL = api.changeAPI(this.siteName, api.basicURL + api.order.noShow)
        const params = {
          memo: "노쇼처리 함",
          bookingNo: this.selectedBookingNo
        }

        this.$http.post(reqURL, params,
          {headers: {'Authorization': `Bearer ${this.currentUser.tokens.access.token}`}}
        ).then(res => {
          if(res.data.code === "OK") {
            alert('노쇼처리 되었습니다.');
            this.hideModal()
            this.searchData()
          } else {
            throw 400
          }
        }).catch(err => {
          alert(err.response.data.message);
        })
      }
    },

    //노쇼취소처리
    cancelNoShow(memo) {

      const reqURL = api.changeAPI(this.siteName, api.basicURL + api.order.cancelNoShow)
      const params = {
        memo: memo,
        bookingNo: this.selectedBookingNo,
        transactionNo: this.visitedInfo.transactionNo
      }

      eventBus.$emit('bus-event', true);

      this.$http.post(reqURL, params,
        {headers: {'Authorization': `Bearer ${this.currentUser.tokens.access.token}`}}
      ).then(res => {
        eventBus.$emit('bus-event', false);
        if(res.data.code === "OK") {
          alert('노쇼취소처리 되었습니다.')
          this.searchData()
        } else {
          throw 400
        }
      }).catch(err => {
        eventBus.$emit('bus-event', false);
        alert(err.response.data.message);
      })

    },

    //예약방문처리
    setVisited() {
      let errFlag = true

      let selectedItemIds = [];
      this.bookingInfo.orderItems.forEach(function(value, index) {
        if(value.unused) {
          selectedItemIds.push(value.itemNo)
          errFlag = false
        }
      })

      if(errFlag) {
        alert('방문완료 처리 할 쿠폰을 선택해주세요.')
        return false
      }
      if(confirm('방문완료 처리 하시겠습니까?')) {
        //방문완료 처리 필요
        const reqURL = api.changeAPI(this.siteName, api.basicURL + api.order.visitStore)
        const params = {
          bookingNo: this.selectedBookingNo,
          orderItems: selectedItemIds,
          memo: null
        }

        eventBus.$emit('bus-event', true);
        this.$http.post(reqURL, params, {
          headers: {'Authorization': `Bearer ${this.currentUser.tokens.access.token}`}
        }).then(res => {
          eventBus.$emit('bus-event', false);
          if(res.data.code === "OK") {
            alert('처리 완료 하였습니다.')
            this.hideModal()
            this.searchData()
          } else {
            throw 400
          }
        }).catch(err => {
          eventBus.$emit('bus-event', false);
          alert(err.response.data.message);
        })
      }
    },


    //방문처리내역조회
    visitedShow(item, bookingNo) {
      this.noShowFlag = item.noShow
      this.selectedBookingNo = bookingNo
      const reqURL = api.changeAPI(this.siteName, api.basicURL + api.order.storeVisitInfo)
      const params = {
        bookingNo: bookingNo
      }
      this.$http.post(reqURL, params,
        {headers: {'Authorization': `Bearer ${this.currentUser.tokens.access.token}`}}
      ).then(res => {
        if(res.data.code === "OK") {
          // console.log(res.data.data)
          this.visitedInfo = res.data.data
          this.$refs.modal_visited_cancel.open()
        } else {
          throw 400
        }
      }).catch(err => {
        alert(err.response.data.message);
      })
    },


    visitedCancel(memo) {

      const reqURL = api.changeAPI(this.siteName, api.basicURL + api.order.cancelVisitStore)
      const params = {
        memo: memo,
        bookingNo: this.selectedBookingNo,
        transactionNo: this.visitedInfo.transactionNo
      }

      this.$http.post(reqURL, params,
        {headers: {'Authorization': `Bearer ${this.currentUser.tokens.access.token}`}}
      ).then(res => {
        if(res.data.code === "OK") {
          alert('방문취소처리 되었습니다.')
          this.searchData()
        } else {
          throw 400
        }
      }).catch(err => {
        alert(err.response.data.message);
      })

    }

  }

}
</script>

